import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import CloseVansaleForAccountModal from "../../../components/Modal/CloseVansaleForAccountModal";
import ArModal from "../../../components/Modal/ArModal";
import DeliveryModal from "../../../components/Modal/DeliveryModal";
import ImportModal from "../../../components/Modal/ImportModal";
import TeasuryTable from "../../../components/Content/TeasuryTable";
import ViewSoModal from "../../../components/Modal/ViewSoModal";
import DatePicker from "../../../components/DatePicker";
import FormAction from "../../../components/Actions/FormAction";

// Model
import { pkListMasterModel } from "../../../../model/SellProducts/PkListMasterModel";

// Utils
import {
  getDataWithComp,
  deleteData,
  getMaxWdNo,
  getSoWithoutPK,
  getAlert,
  getData,
  formatCurrency,
  parseCurrency,
  getSpRunNumber,
  getDataWithJoin,
} from "../../../../utils/SamuiUtils";

import {
  convertDateFixTime,
  formatDate,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
} from "../../../../utils/DateUtils";

import { manageWhItemData } from "../../../../utils/WarehouseUtils";
import CloseVansaleForWarehouseModal from "../../../components/Modal/CloseVansaleForWarehouseModal";
import { ExportVansaleSalesReport } from "../../../../utils/ExportUtils";
import moment from "moment";

function Form({
  callInitialize,
  mode,
  setMode,
  name,
  maxDocNo,
  onRowSelected,
  getReport,
}) {
  const [formMasterList, setFormMasterList] = useState(pkListMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [formWdList, setFormWdList] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [soDataList, setSoDataList] = useState([]);
  const [dlLineList, setDlLineList] = useState([]);

  // รายละเอียดการส่งสินค้า & ใบขาย
  const [soListData, setSoListData] = useState([]);
  const [itemList, setItemList] = useState([]);

  // รถส่งสินค้า
  const [carList, setCarList] = useState([]);

  // คนขับรถส่งสินค้า
  const [driverList, setDriverList] = useState([]);

  // การแสดงสถานะใบ
  const [docStatus, setDocStatus] = useState(null);
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");
  const [reqStcStatusName, setReqStcStatusName] = useState("");
  const [reqStcStatusColour, setReqStcStatusColour] = useState("");
  const [dlLineName, setDlLineName] = useState("");

  // ตัวแปรประเภทการดึงข้อมูลจาก DeliveryModal (SO = ใบขาย, DL = สายส่ง)
  const [selectedType, setSelectedType] = useState("");

  // การใช้ Tab เพื่อเปลี่ยน Form
  const [activeTab, setActiveTab] = useState("deliveryDetails");

  // ใช้สำหรับเก็บค่าสูงของ WD (ใบเบิก)
  const [maxWdNo, setMaxWdNo] = useState();

  // ใช้สำหรับแสดงสินค้าคงคลัง
  const [selectedWarehouseCode, setSelectedWarehouseCode] = useState("");
  const [formItemOnHandCaseTab, setFormItemOnHandCaseTab] = useState([]);
  const [formItemWithdrawCaseTab, setFormItemWithdrawCaseTab] = useState([]);

  // เก็บค่าของสายส่งไว้หลังบันทึกเสร็จ
  const [deliveryLineId, setDeliveryLineId] = useState(null);

  // เก็บค่าสำหรับ onLoad เมื่อกดยืนยันการนำเข้า
  const [selectedImports, setSelectedImports] = useState([]);
  const [onLoadConfirm, setOnLoadConfirm] = useState(false);

  // สำหรับเปิดสลิปเงินโอน
  const [showSlipModal, setShowSlipModal] = React.useState(false);

  const [showChequeModal, setShowChequeModal] = useState(false);
  const [chequeNo, setChequeNo] = React.useState("");
  const [chequeName, setChequeName] = React.useState("");
  const [chequeBranch, setChequeBranch] = React.useState("");
  const [chequeDate, setChequeDate] = React.useState("");

  const [payDatetime, setPayDatetime] = React.useState("");

  // สำหรับ Freeze หน้าจอตอนทำรายการ
  const [isLoading, setIsLoading] = useState(false);

  // สำหรับค้นหาลูกค้า
  const [searchCustomer, setSearchCustomer] = useState('');

  // สำหรับ Dialog Confirm ลบลูกค้าทั้งหมด
  const [showConfirmDeleteAllCustomerModal, setShowConfirmDeleteAllCustomerModal] = useState(false);

  // สำหรับเก็บ List ที่ลบลูกค้า
  const [removedCustomerList, setRemovedCustomerList] = useState([]);

  // สำหรับเก็บหลักฐานโอน
  const [slipImage, setSlipImage] = useState("");

  const [paymentHistory, setPaymentHistory] = React.useState([]);

  useEffect(() => {
    initialize();
  }, []);

  // รอบให้ Default ตามเวลาปัจจุบัน แต่ยังคงให้เลือกได้อยู่ แค่ Default เฉยๆ (รอพี่แบงค์ทดสอบ)
  // => เช้า 06:00 - 11:59
  // => บ่าย 12:00 - 17:59
  // => ค่ำ 18:00 - 05:59
  useEffect(() => {
    const currentHour = new Date().getHours();
    let round;

    if (currentHour >= 6 && currentHour < 12) {
      round = "1"; // 1 = รอบเช้า (อ้างอิงจาก PKList_H)
    } else if (currentHour >= 12 && currentHour < 18) {
      round = "2"; // 2 = รอบบ่าย (อ้างอิงจาก PKList_H)
    } else {
      round = "3"; // 3 = รอบค่ำ (อ้างอิงจาก PKList_H)
    }

    setFormMasterList((prevState) => ({
      ...prevState,
      pkRound: round,
    }));
  }, []);

  const initialize = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      const arDataList = await getDataWithComp(
        "Tb_Set_AR",
        "ORDER BY AR_Code ASC"
      );
      if (arDataList && arDataList.length > 0) {
        setArDataList(arDataList);
      }

      const soDataList = await getSoWithoutPK();
      if (soDataList && soDataList.length > 0) {
        setSoDataList(soDataList);
      }

      const dlDataList = await getDataWithComp(
        "DL_Line_H",
        "ORDER By DL_Id ASC"
      );
      if (dlDataList && dlDataList.length > 0) {
        setDlLineList(dlDataList);
      }

      // หาค่าสูงของ WHDocNo ใน WHDOC_H สำหรับ WD (ใบเบิก)
      const findMaxWdNo = await getDataWithComp(
        "WHDoc_H",
        `AND WHDoc_Type = '3' ORDER BY WHDoc_No DESC`
      );
      const maxWd = getMaxWdNo(findMaxWdNo);
      setMaxWdNo(maxWd);

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo();
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message);
    }
  };

  const getModelByNo = async () => {
    try {
      const findMaster = await getDataWithComp("PKList_H", ``);
      const fromDatabase = findMaster.find((pk) => pk.Doc_No === maxDocNo);

      if (!fromDatabase) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูล VIEW
      const findViewMaster = await getDataWithComp("API_0801_PKList_H", "");
      const fromView = findViewMaster.find((data) => data.Doc_No === maxDocNo);
      setDocStatus(fromView.Doc_Status);
      setStatusName(fromView.DocStatus_Name);
      setStatusColour(fromView.DocStatus_Colour);
      setReqStcStatusName(fromView.RequestSTCStatus_Name);
      setReqStcStatusColour(fromView.RequestSTCStatus_Colour);
      setDlLineName(fromView.DL_LineName);

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromViewDetail = await getData(
        "API_0802_PKList_D",
        `Doc_Id = ${fromDatabase.Doc_Id} ORDER BY DL_Queue ASC`
      );

      // ดึง SO_Id ทั้งหมด
      const soIds = fromViewDetail
        .map((data) => data.SO_Id)
        .filter((id) => id !== null && id !== undefined);

      let soMap = new Map();
      if (soIds.length > 0) {
        const soData = await getData(
          "API_0701_SO_H",
          `Doc_ID IN (${soIds.join(",")})`
        );

        // สร้าง Map { Doc_ID => Doc_No }
        soMap = new Map(soData.map((so) => [so.Doc_ID, String(so.Doc_No)]));
      }

      // 1 จากใบขาย || 2 จากสายส่ง
      if (parseCurrency(fromDatabase.PKDoc_Type) === 1) {
        // ใบขาย
        setSelectedType("SO");
        setFormDetailList([]);

        const updatedFormDetails = await Promise.all(
          fromViewDetail.map(async (data) => ({
            docId: data.Doc_Id,
            dlQueue: data.DL_Queue,
            arId: data.AR_Id,
            arCode: data.AR_Code,
            arName: data.AR_Name,
            arShotName: data.AR_ShortName,
            soId: data.SO_Id,
            docNo: soMap.get(data.SO_Id) ?? "",
          }))
        );

        setFormDetailList(updatedFormDetails);

        await fetchCarAndDriverList(null);
      } else if (parseCurrency(fromDatabase.PKDoc_Type) === 2) {
        // สายส่ง
        setSelectedType("DL");
        setDeliveryLineId(fromDatabase.Delivery_Line_Id);
        setFormDetailList([]);

        const updatedFormDetails = await Promise.all(
          fromViewDetail.map(async (data) => ({
            docId: data.Doc_Id,
            dlQueue: data.DL_Queue,
            arId: data.AR_Id,
            arCode: data.AR_Code,
            arName: data.AR_Name,
            arShotName: data.AR_ShortName,
            soId: data.SO_Id,
            docNo: soMap.get(data.SO_Id) ?? "",
          }))
        );

        setFormDetailList(updatedFormDetails);

        await fetchCarAndDriverList(fromDatabase.Delivery_Line_Id);
      } else {
        setIsLoading(false);
        getAlert(
          "FAILED",
          "ไม่พบประเภทข้อมูลอ้างอิงเอกสาร กรุณาลองใหม่อีกครั้ง"
        );
      }

      setFormMasterList({
        docId: fromDatabase.Doc_Id,
        compId: fromDatabase.Comp_Id,
        docNo: fromDatabase.Doc_No,
        docDate: fromDatabase.Doc_Date || null,
        docStatus: fromDatabase.Doc_Status,
        reqStcStatus: fromDatabase.Request_STC_Status,
        deliveryLineId: fromDatabase.Delivery_Line_Id,
        pkCarId: fromDatabase.PK_Car_Id,
        pkCarNo: fromDatabase.PK_Car_No,
        pkRound: String(fromDatabase.PK_Round),
        pkDriver1Id: fromDatabase.PK_Driver1_Id,
        pkDriver2Id: fromDatabase.PK_Driver2_Id,
        pkDriver3Id: fromDatabase.PK_Driver3_Id,
        createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
        createdByName: fromDatabase.Created_By_Name,
        createdById: fromDatabase.Created_By_Id,
        updateDate: getCreateDateTime(),
        updateByName: window.localStorage.getItem("name"),
        updateById: window.localStorage.getItem("emp_id"),
        cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
        cancelByName: fromDatabase.Cancel_By_Name,
        cancelById: fromDatabase.Cancel_By_Id,
        pkDocType: fromDatabase.PKDoc_Type,
      });

      // เรียกใช้ฟังชั่นดึงข้อมูลสินค้าคงเหลือ
      setSelectedWarehouseCode(fromDatabase.PK_Car_No);
      await onLoadOnHandCaseTab(fromDatabase.PK_Car_No);
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // API_1101_WH_ITEM_ONHAND (สินค้าคงคลัง)
  const onLoadOnHandCaseTab = async (whCode) => {
    try {
      // เคลียค่าว่างทุกครั้ง
      setFormItemOnHandCaseTab([]);

      if (whCode != null) {
        const itemOnHandCaseTab = await getDataWithComp(
          "API_1101_WH_ITEM_ONHAND",
          `AND WH_Code = '${whCode}' ORDER BY Item_Code ASC`
        );

        if (itemOnHandCaseTab && itemOnHandCaseTab.length > 0) {
          // กรองข้อมูลที่ Item_Onhand มีค่าเป็น 0 หรือน้อยกว่า 0
          const filteredItems = itemOnHandCaseTab.filter(
            (item) => item.Item_Onhand > 0
          );
          setFormItemOnHandCaseTab(filteredItems);
        }
      }
    } catch (error) {
      getAlert("FAILED", error.message);
      setFormItemOnHandCaseTab([]);
    }
  };

  const onLoadWithdrawCaseTab = async (selectedImports) => {
    try {
      // เคลียค่าข้อมูลสินค้าใน state ทุกครั้ง
      setFormItemWithdrawCaseTab([]);

      if (selectedImports && selectedImports.length > 0) {
        for (const importData of selectedImports) {
          // เรียกข้อมูลสินค้า
          let itemWd = await getDataWithComp(
            "API_1002_WHDOC_D",
            `AND WHDoc_Id = ${importData.WHDoc_Id} ORDER BY Line ASC`
          );

          // ถ้ามีสินค้าให้เพิ่มเข้าไปใน state ทีละชุด
          if (itemWd && itemWd.length > 0) {
            setFormItemWithdrawCaseTab((prevItems) => [
              ...prevItems,
              ...itemWd,
            ]);
          }
        }
      }
    } catch (error) {
      getAlert("FAILED", error.message);
      setFormItemOnHandCaseTab([]); // แก้เงื่อนไขตอนเกิด error
    }
  };

  const handleSubmit = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบว่า formMasterList ต้องระบุรอบด้วย
      if (formMasterList.pkRound === null || formMasterList.pkRound === "") {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกรอบ");
        return;
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มอ้างอิงเอกสารสำหรับทำใบ Picking List");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบการเลือกรถส่งสินค้า
      if (formMasterList.pkCarId === null || formMasterList.pkCarId === "") {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกรถส่งสินค้า");
        return;
      }

      // ตรวจสอบการเลือกคนขับรถส่งสินค้าอย่างน้อย 1 คน
      if (
        (formMasterList.pkDriver1Id === null ||
          formMasterList.pkDriver1Id === "") &&
        (formMasterList.pkDriver2Id === null ||
          formMasterList.pkDriver2Id === "") &&
        (formMasterList.pkDriver3Id === null ||
          formMasterList.pkDriver3Id === "")
      ) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกคนขับรถส่งสินค้าอย่างน้อย 1 คน");
        return;
      }

      // ค้นหาทะเบียนรถ
      const getCarNoByCarId = async (pkCarId) => {
        if (pkCarId === null || pkCarId === "") {
          return null;
        }
        const viewCar = await getData("Tb_Set_Car", `Car_id = ${pkCarId}`);
        return String(viewCar[0].Car_No);
      };

      // ตรวจสอบว่ารถคันนี้ที่เลือกมา ได้สร้าง Picking List ไปหรือยัง
      const checkCarExist = await getDataWithComp(
        "PKList_H",
        `AND Doc_Status IN ('1','2') AND PK_Car_Id = ${parseCurrency(formMasterList.pkCarId)}`
      );
      if (checkCarExist && checkCarExist.length > 0) {
        setIsLoading(false);
        getAlert(
          'FAILED',
          `รถ ${formMasterList.pkCarNo} มีการเปิด Picking List นี้อยู่แล้ว ไม่สามารถสร้าง Picking List ซ้ำซ้อนได้ กรุณาปิดงานให้สมบูรณ์ผ่านระบบหลังบ้านก่อน`
        );
        return;
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: await getSpRunNumber("PK"),
        doc_date: convertDateFixTime(formMasterList.docDate),
        doc_status: parseCurrency("1", 10),
        req_stc_status: parseCurrency("0", 10),
        delivery_line_id: deliveryLineId,
        pk_car_id: formMasterList.pkCarId,
        pk_car_no: await getCarNoByCarId(formMasterList.pkCarId || null),
        pk_round: parseCurrency(formMasterList.pkRound, 10),
        pk_driver_1_id: formMasterList.pkDriver1Id,
        pk_driver_2_id: formMasterList.pkDriver2Id,
        pk_driver_3_id: formMasterList.pkDriver3Id,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        pk_doc_type:
          selectedType === "SO" ? 1 : selectedType === "DL" ? 2 : null,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-pk-list-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        try {
          const getDocIdResponse = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
            {
              table: "PKList_H",
              doc_no: formMasterData.doc_no,
              comp_id: window.localStorage.getItem("company"),
            },
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          if (getDocIdResponse && getDocIdResponse.data.length > 0) {
            const docId = parseCurrency(getDocIdResponse.data[0].Doc_Id, 10);

            const bulkItems = formDetailList.map((item, index) => ({
              doc_id: docId,
              dl_queue: index + 1,
              ar_id: item.arId,
              ar_code: item.arCode,
              ar_name: item.arName,
              so_id: item.soId,
            }));

            try {
              await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/create-pk-list-d-bulk`,
                { items: bulkItems },
                { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
              );
            } catch (bulkErr) {
              for (const itemData of bulkItems) {
                await Axios.post(
                  `${process.env.REACT_APP_API_URL}/api/create-pk-list-d`,
                  itemData,
                  { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
                );
              }
            }
          }

          await onRowSelected(formMasterData.doc_no);
          await getModelByNo();
          await handleChangeTabs("withdraw");

          setTimeout(() => {
            handleImportShow();
          }, 500);

          getAlert(response.data.status, response.data.message);
        } catch (error) {
          setIsLoading(false);
          getAlert("FAILED", error || error.message);
        }
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      setIsLoading(true);

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มอ้างอิงเอกสารสำหรับทำใบ Picking List");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // เฉพาะแก้ไขข้อมูลของสายส่ง
      if (selectedType === "DL") {
        if (formMasterList.pkCarId === null || formMasterList.pkCarId === "") {
          setIsLoading(false);
          getAlert("FAILED", "กรุณาเลือกรถส่งสินค้า");
          return;
        }
        if (
          (formMasterList.pkDriver1Id === null ||
            formMasterList.pkDriver1Id === "") &&
          (formMasterList.pkDriver2Id === null ||
            formMasterList.pkDriver2Id === "") &&
          (formMasterList.pkDriver3Id === null ||
            formMasterList.pkDriver3Id === "")
        ) {
          setIsLoading(false);
          getAlert("FAILED", "กรุณาเลือกคนขับรถอย่างน้อย 1 คน");
          return;
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: formMasterList.docNo,
        doc_date: formMasterList.docDate,
        doc_status: formMasterList.docStatus,
        req_stc_status: formMasterList.reqStcStatus,
        delivery_line_id: formMasterList.deliveryLineId,
        pk_car_id: formMasterList.pkCarId,
        pk_car_no: formMasterList.pkCarNo,
        pk_round: parseCurrency(formMasterList.pkRound, 10),
        pk_driver_1_id: formMasterList.pkDriver1Id,
        pk_driver_2_id: formMasterList.pkDriver2Id,
        pk_driver_3_id: formMasterList.pkDriver3Id,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(formMasterList.updateDate),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        cancel_date: formMasterList.cancelDate,
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        pk_doc_type: formMasterList.pkDocType,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-pk-list-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        const docId = parseCurrency(formMasterList.docId, 10);

        // ส่งข้อมูลลูกค้าที่ถูกลบไปที่ API /create-pk-list-d-log-del
        if (removedCustomerList && removedCustomerList.length > 0) {
          try {
            for (const dataRemove of removedCustomerList) {
              await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/create-pk-list-d-log-del`,
                {
                  doc_id: docId,
                  dl_queue: dataRemove.dlQueue,
                  ar_id: dataRemove.arId,
                  ar_code: dataRemove.arCode,
                  ar_name: dataRemove.arName,
                  so_id: dataRemove.soId,
                  trans_so_status: dataRemove.soId ? 1 : 0,
                  is_del: "Y",
                  is_add: "N",
                  del_date: moment().utcOffset(7, true).format("YYYY-MM-DD HH:mm:ss.SSS"),
                  del_by: localStorage.getItem("name"),
                  add_date: null,
                  add_by: null
                },
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );
            }
          } catch (logDelErr) {
            getAlert("FAILED", "บันทึกลูกค้าที่ถูกลบไม่สำเร็จ: " + (logDelErr?.response?.data?.message || logDelErr.message));
          }
        }

        // ก่อนจะลบ ไปเอาข้อมูลมา Backup ไว้ก่อน
        const backUpDetail = await getData("PKList_D", `Doc_ID = ${docId}`);

        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData("PKList_D", `WHERE Doc_ID = ${docId}`);

        // Map SO_Id จาก backupDetail ไปยัง formDetailList ตาม ar_id
        const updatedFormDetailList = formDetailList.map((item) => {
          const backupItem = backUpDetail.find((detail) => detail.AR_Id === item.arId);
          return {
            ...item,
            soId: backupItem ? backupItem.SO_Id : item.soId,
          };
        });

        // ส่งข้อมูลใหม่ไปบันทึก
        const bulkItems = updatedFormDetailList.map((item, index) => ({
          doc_id: parseCurrency(docId, 10),
          dl_queue: index + 1,
          ar_id: item.arId,
          ar_code: item.arCode,
          ar_name: item.arName,
          so_id: item.soId,
        }));

        try {
          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-pk-list-d-bulk`,
            { items: bulkItems },
            { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
          );
        } catch (bulkErr) {
          for (const itemData of bulkItems) {
            await Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-pk-list-d`,
              itemData,
              { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
            );
          }
        }

        await onRowSelected(formMasterData.doc_no);
        await getModelByNo();

        setIsLoading(false);
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      setIsLoading(true);

      // ตรวจสอบข้อมูลที่จำเป็นก่อนเริ่มทำงาน
      if (!formMasterList.docNo || !formMasterList.docId) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่พบรหัสเอกสาร");
        return;
      }

      // เพิ่มการตรวจสอบว่า ต้องยกเลิกใบขายทั้งหมดก่อน ถึงจะให้ยกเลิกใบ PK
      const formSoList = await getDataWithComp(
        "API_0701_SO_H",
        `AND Doc_Status <> 13 AND Ref_DocID = ${formMasterList.docId} ORDER BY Doc_No ASC`
      );

      if (formSoList && formSoList.length > 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณายกเลิกใบขายก่อนยกเลิกใบรายงานส่งสินค้า");
        return;
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API สำหรับการยกเลิก
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-pk-list-h`,
        formMasterData,
        { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
      );

      // ค้นหาใบเบิกสินค้าที่เกี่ยวข้องกับ Picking List
      const findWhDocById = await getDataWithComp(
        "WHDoc_H",
        `AND Ref_DocID = ${formMasterList.docId}`
      );

      if (findWhDocById && findWhDocById.length > 0) {
        // #####################################
        // อัปเดตใบเบิกสินค้าที่เชื่อมโยงกับ Picking List โดยตั้งค่า ref_doc_id เป็น null
        // #####################################
        for (const whDocData of findWhDocById) {
          // อัปเดต ref_doc_id เป็น null
          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/update-ref-doc-by-no`,
            {
              wh_doc_no: whDocData.WHDoc_No,
              ref_doc_id: null,
              comp_id: localStorage.getItem("company"),
            },
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          // อัปเดตสถานะเอกสาร
          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/update-doc-status-by-no`,
            {
              wh_doc_no: whDocData.WHDoc_No,
              status: 2,
              comp_id: localStorage.getItem("company"),
            },
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        }
      }

      // ลบของทุกอย่างออกจากรถ
      const warehouse = await getDataWithComp('Tb_Set_WH', `AND Flag_Vansale = 'Y' AND WH_Status = 'Y' AND WH_Code = '${formMasterList.pkCarNo}'`);
      if (warehouse && warehouse.length > 0) {
        await deleteData('WH_ITEM_Onhand', `WHERE WH_Id = ${warehouse[0].WH_Id}`);
      }

      // รีเฟรชข้อมูลและแสดงข้อความตอบกลับจาก API
      callInitialize();
      setIsLoading(false);
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleChangeMaster = async (e) => {
    const { name, value } = e.target;

    if (name === "pkCarId") {
      // เคลียค่าเดิม
      // setFormMasterList((prev) => ({
      //   ...prev,
      //   pkCarId: "",
      // }));

      // กรองหาข้อมูลที่ต้องการจาก carList
      const getCarNo = carList.find((car) => {
        const carId = selectedType === "SO" ? car.Car_id : car.DL_Car_id;

        // เปรียบเทียบ carId กับ value โดยแปลงเป็น String
        return carId.toString() === value.toString();
      });

      // ถ้าพบข้อมูลของรถ ให้ทำการเพิ่มค่าใน formMasterList.pkCarNo
      if (getCarNo) {
        setFormMasterList((prev) => ({
          ...prev,
          [name]: value,
          pkCarNo: getCarNo.Car_No, // ใช้ Car_No แทน DL_Car_No ถ้า DL_Car_No ไม่พบ
        }));

        // เรียกใช้ฟังชั่นดึงข้อมูลสินค้าคงเหลือ
        setSelectedWarehouseCode(getCarNo.Car_No);
        await onLoadOnHandCaseTab(getCarNo.Car_No);

        return;
      }
    }

    // เช็คคนขับที่ถูกเลือก
    const selectedDrivers = [
      formMasterList.pkDriver1Id,
      formMasterList.pkDriver2Id,
      formMasterList.pkDriver3Id,
    ];

    if (
      name === "pkDriver1Id" ||
      name === "pkDriver2Id" ||
      name === "pkDriver3Id"
    ) {
      // ตรวจสอบว่าคนขับที่เลือกซ้ำกับคนขับที่มีอยู่หรือไม่
      if (selectedDrivers.includes(value)) {
        getAlert("FAILED", "ไม่สามารถเลือกคนขับซ้ำกันได้");

        // เคลียร์ค่าของฟิลด์ที่เลือก
        setFormMasterList((prev) => ({
          ...prev,
          [name]: "",
        }));

        return;
      }
    }

    // อัปเดตค่าใน formMasterList ปกติสำหรับ field อื่น ๆ
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value ? value.format('YYYY-MM-DD') : null,
    }));
  };

  const handleChangeTabs = async (value) => {
    setActiveTab(value);
    if (value === "stockRemaining") {
      setItemList([]);
      await onLoadOnHandCaseTab(selectedWarehouseCode);
    }
    if (value === "withdraw") {
      await onLoadWithdrawCaseTab(formWdList);
    }
  };

  // SET SO
  const [showSoModal, setShowSoModal] = useState(false);
  const handleSoShow = () => setShowSoModal(true);
  const handleSoClose = () => setShowSoModal(false);
  const onRowSelectSo = async (soSelected) => {
    try {
      setSelectedType("SO");

      const soSelectedList = soSelected.map((item, index) => ({
        docId: null,
        dlQueue: index + 1,
        arId: item.AR_Id,
        arCode: item.AR_Code,
        arName: item.AR_Name,
        arShotName: item.AR_ShortName,
        soId: item.Doc_ID,
        docNo: item.Doc_No,
      }));

      setFormDetailList(soSelectedList);
      handleSoClose();
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };
  const onConfirmSoSelection = async (soSelected) => {
    try {
      if (!soSelected[0]) {
        getAlert("FAILED", "ท่านยังไม่ได้เลือกใบขายสินค้า");
        return;
      }

      setFormDetailList([]);
      setCarList([]);
      setDriverList([]);

      onRowSelectSo(soSelected);

      // หารถส่งสินค้า && หาคนขับรถส่งสินค้า
      await fetchCarAndDriverList(``);

      handleSoClose();

      // แจ้งเตือนผู้ใช้ว่าการเลือกสำเร็จ
      getAlert("OK", "การเลือกใบขายสินค้าสำเร็จ");
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET DL
  const onRowSelectDL = async (dlSelected) => {
    try {
      setIsLoading(true);

      // เก็บประเภทการดึงข้อมูลจาก DeliveryModal && รีเซ็ตค่า formDetailList
      setSelectedType("DL");
      setFormDetailList([]);

      // เก็บไอดีของสายส่งเอาไว้ใน State ด้วย เพื่อที่จะได้เอาไปบันทึก
      setDeliveryLineId(dlSelected.DL_Id);

      // หาสายส่ง
      const findLineList = await getData(
        "View_DL_Line",
        `DL_Id = ${dlSelected.DL_Id} ORDER BY DL_Queue ASC`
      );

      // ใช้ Array ชั่วคราวในการเก็บรายละเอียดฟอร์ม
      let updatedFormDetails = [];

      if (findLineList && findLineList.length > 0) {
        // เพิ่มรายละเอียดสายส่งลงใน updatedFormDetails
        const dlDetails = findLineList.map((dlLine) => ({
          docId: null,
          dlQueue: dlLine.DL_Queue,
          arId: dlLine.DL_AR_Id,
          arCode: dlLine.AR_Code,
          arName: dlLine.AR_Name,
          arShotName: dlLine.AR_ShortName,
          soId: null,
          docNo: null,
        }));

        // รวมข้อมูลลูกค้าเงินสดและรายละเอียดสายส่ง
        updatedFormDetails = updatedFormDetails.concat(dlDetails);

        // เพิ่มการแสดงสายส่ง
        setDlLineName(findLineList[0].DL_LineName);
      }

      // อัพเดต state ด้วยรายละเอียดที่รวมกัน
      setFormDetailList(updatedFormDetails);

      // หารถส่งสินค้า && หาคนขับรถส่งสินค้า
      await fetchCarAndDriverList(dlSelected.DL_Id);

      handleSoClose();

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  // เปิด Modal สำหรับดูรายละเอียดใบขาย
  const [showViewSoModal, setShowViewSoModal] = useState(false);
  const [selectedSoData, setSelectedSoData] = useState(null);
  const handleViewSoClose = () => {
    setShowViewSoModal(false);
    setSelectedSoData(null);

    // ลบ class 'modal-open' จาก body
    document.body.classList.remove("modal-open");

    // ลบ element ที่อาจถูกซ้อน เช่น backdrop ของ Modal
    const backdrops = document.getElementsByClassName("modal-backdrop");
    while (backdrops.length > 0) {
      backdrops[0].parentNode.removeChild(backdrops[0]);
    }
  };
  const handleViewSo = (soData) => {
    setSelectedSoData(soData);
    setShowViewSoModal(true);
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = (arSelected) => {
    try {
      // สร้างรายการใหม่ที่จะเพิ่มเข้าไปใน formMasterList
      const newRow = {
        docId: null,
        dlQueue: parseCurrency(formDetailList.length) + 1,
        arId: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arShotName: arSelected.AR_ShortName,
        soId: null,
        docNo: null,
      };

      setFormDetailList((prevState) => {
        if (prevState.length === 0) {
          // ถ้า formMasterList ว่างเปล่า, ให้สร้างรายการใหม่
          return [newRow];
        }

        // ตรวจสอบว่ามีข้อมูลเดียวกันในรายการแล้วหรือไม่
        const isAlreadyPresent = prevState.some(
          (item) => item.arId === arSelected.AR_Id
        );

        // ถ้ามีข้อมูลอยู่แล้ว แจ้งเตือน + คืนค่าเดิม
        if (isAlreadyPresent) {
          getAlert("FAILED", "ไม่สามารถเพิ่มลูกค้าซ้ำกันได้");
          return prevState;
        }

        // เพิ่มรายการใหม่ถ้ายังไม่มี
        return [...prevState, newRow];
      });

      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // SET IMPORT
  const [showImportModal, setShowImportModal] = useState(false);
  const handleImportShow = () => setShowImportModal(true);
  const handleImportClose = () => setShowImportModal(false);
  const onConfirmImportSelection = async (importSelected) => {
    try {
      if (!importSelected[0]) {
        getAlert("FAILED", "ท่านยังไม่ได้เลือกใบเบิกเพื่อเตรียมของเข้ารถ");
        return;
      }

      const updatedFormWdList = [...formWdList];
      importSelected.forEach((importData) => {
        const existingIndex = updatedFormWdList.findIndex(
          (existingData) => existingData.WHDoc_No === importData.WHDoc_No
        );

        if (existingIndex !== -1) {
          updatedFormWdList[existingIndex] = importData;
        } else {
          updatedFormWdList.push(importData);
        }
      });

      // เก็บค่าที่เลือกไว้ใน selectedImports
      setSelectedImports(importSelected);

      await handleImportClose();

      setFormWdList(updatedFormWdList);
      await onLoadWithdrawCaseTab(importSelected);
      await onRowSelected(formMasterList.docNo);
      await getModelByNo();
      // getAlert("OK", "เตรียมของเข้ารถสำเร็จ");
    } catch (error) {
      getAlert("FAILED", "เกิดข้อผิดพลาดในการเลือกนำเข้าสำเร็จ");
    }
  };
  const handleConfirmImport = async () => {
    try {
      // ทำการ SET OnLoad ตอนเข้าครั้งแรก
      setOnLoadConfirm(true);

      // ทำการตัด Stock จากรายการนำเข้า
      if (formWdList && formWdList.length > 0) {
        for (const formWd of formWdList) {
          let formMasterData = {
            wh_doc_no: formWd.WHDoc_No,
            ref_doc_id: formMasterList.docId,
            comp_id: localStorage.getItem("company"),
          };
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/update-ref-doc-by-no`,
            formMasterData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          // อัปเดตสถานะเอกสาร
          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/update-doc-status-by-no`,
            {
              wh_doc_no: formWd.WHDoc_No,
              status: 3,
              comp_id: localStorage.getItem("company"),
            },
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          // ตรวจสอบสถานะการตอบกลับ
          if (response.data.status === "OK") {
            try {
              let detailList = await getData(
                "WHDoc_D",
                `WHDoc_Id = ${parseCurrency(formWd.WHDoc_Id)} ORDER BY Line ASC`
              );

              if (detailList && detailList.length > 0) {
                for (const detail of detailList) {
                  let findWarehouse = await getDataWithComp(
                    "WHDoc_H",
                    `AND WHDoc_Id = ${parseCurrency(detail.WHDoc_Id)}`
                  );

                  // ย้ายออก
                  await manageWhItemData(
                    detail.Item_Id, // Item ไอดีของสิ่งนั้นๆ
                    detail.Item_Code, // Item โค้ดของสิ่งนั้นๆ
                    detail.Item_Name, // ชื่อ Item นั้นๆ
                    findWarehouse[0].F_WH_Id, // WarehouseID ของไอเทม
                    "TO", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
                    parseCurrency(detail.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
                    formMasterList.docId, // ไอดีเอกสาร
                    maxDocNo, // เลขเอกสาร
                    formWd.WHDoc_No, // เลขเอกสารอ้างอิง
                    formWd.WHDoc_Remark // หมายเหตุ
                  );

                  // ย้ายเข้า
                  await manageWhItemData(
                    detail.Item_Id, // Item ไอดีของสิ่งนั้นๆ
                    detail.Item_Code, // Item โค้ดของสิ่งนั้นๆ
                    detail.Item_Name, // ชื่อ Item นั้นๆ
                    findWarehouse[0].T_WH_Id, // WarehouseID ของไอเทม
                    "TI", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
                    parseCurrency(detail.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
                    formMasterList.docId, // ไอดีเอกสาร
                    maxDocNo, // เลขเอกสาร
                    formWd.WHDoc_No, // เลขเอกสารอ้างอิง
                    formWd.WHDoc_Remark // หมายเหตุ
                  );
                }
              }
            } catch (error) {
              getAlert("FAILED", error || error.message);
            }
          }
        }
        await handleRemoveFormWd();
        setOnLoadConfirm(false);
        getAlert(
          "OK",
          "ยืนยันรายการนำเข้าสินค้าทั้งหมด " +
          formItemWithdrawCaseTab.length +
          " รายการสำเร็จ"
        );
      }
    } catch (error) {
      setOnLoadConfirm(false);
      getAlert("FAILED", error || error.message);
    }
  };

  const handleRemoveFormWd = () => {
    setFormWdList([]);
    setFormItemWithdrawCaseTab([]);
    setSelectedImports([]);
    // getAlert("OK", "ยกเลิกรายการนำเข้าสินค้าสำเร็จ");
  };

  const fetchCarAndDriverList = async (dlId) => {
    let findCarList;

    if (dlId) {
      // ถ้า dlId มีค่า
      findCarList = await getDataWithComp("View_DL_Car", `AND DL_Id = ${dlId}`);
    } else {
      // ถ้า dlId ไม่มีค่า
      findCarList = await getDataWithComp("Tb_Set_Car", `AND Car_Status = 'Y'`);
    }

    if (findCarList && findCarList.length > 0) {
      setCarList(findCarList);
    } else {
      setCarList([]); // เผื่อกรณีไม่มีข้อมูล
    }

    // หาคนขับรถส่งสินค้า
    const findDriverList = await getDataWithComp(
      "Tb_Set_Employee",
      `AND Emp_Status = 'Y' AND Driver_Flag = 'Y'`
    );
    if (findDriverList && findDriverList.length > 0) {
      setDriverList(findDriverList);
    } else {
      setDriverList([]); // เผื่อกรณีไม่มีข้อมูล
    }
  };

  // แสดงรายละเอียดการส่งสินค้า (แค่แสดงเฉยๆ ไม่ได้ Map Field ข้อมูลไปบันทึก)
  const handleDisplayItem = async (data) => {
    try {
      // อัปเดต Active Tab
      setActiveTab("deliveryDetails");

      // เคลียร์ค่าก่อนโหลดข้อมูลใหม่
      setSoListData([]);
      setItemList([]);
      setFormItemOnHandCaseTab([]);

      // ค้นหาใบขาย (SO)
      const findSoList = await getData(
        "API_0701_SO_H",
        `AR_ID = ${data.arId} AND Doc_Is_PickingList = ${data.docId}`
      );

      if (findSoList && findSoList.length > 0) {
        const soDataWithDetails = await Promise.all(
          findSoList.map(async (so) => {
            const soDetails = await getData(
              "API_0702_SO_D",
              `Doc_ID = ${so.Doc_ID}`
            );
            return {
              ...so,
              details: soDetails || [], // เพิ่ม `details` สำหรับแต่ละใบขาย
            };
          })
        );

        setSoListData(soDataWithDetails);
      } else {
        setSoListData([]);
      }

      // ดึงประวัติการชำระเงิน
      const paymentHistoryResponse = await getData(
        "Pay_History",
        `DocCode_Id = 7 AND Doc_Id = ${data.soId}`
      );

      if (paymentHistoryResponse && paymentHistoryResponse.length > 0) {
        setPaymentHistory(paymentHistoryResponse);

        for (const payment of paymentHistoryResponse) {
          if (payment.Pay_Type === 3) {
            setChequeNo(payment.Pay_Cheque_No);
            setChequeName(payment.Pay_Cheque_Name);
            setChequeBranch(payment.Pay_Cheque_Branch);
            setChequeDate(formatDate(payment.Pay_Cheque_date, false));
          }

          setPayDatetime(formatDate(payment.Pay_Datetime, false));
        }
      }

    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const handleShowImage = async (soData) => {
    const fromSlip = await getData(
      "Upload_File_List",
      `DocCode_ID = 7 AND Doc_ID = ${soData.Doc_ID}`
    );

    if (fromSlip && fromSlip.length > 0) {
      setSlipImage(fromSlip[0].File_Url);
    } else {
      setSlipImage("");
    }

    setShowSlipModal(true);
  };

  // ลบข้อมูลรายชื่อลูกค้าและเก็บไว้ใน removedCustomerList
  const handleRemove = (index, event) => {
    try {
      // ไม่ให้มันไปเข้าฟังชั่น handleDisplayItem
      event.stopPropagation();

      if (formDetailList.length > 1) {
        // เก็บข้อมูลลูกค้าที่จะลบ
        setRemovedCustomerList((prevList) => [
          ...prevList,
          formDetailList[index],
        ]);
        // ลบลูกค้าออกจาก formDetailList
        setFormDetailList((prevState) => {
          const updatedList = prevState.filter((_, i) => i !== index);
          return updatedList;
        });
      } else {
        getAlert(
          "FAILED",
          "ไม่สามารถลบลูกค้าได้ เนื่องจากการสร้างใบ Picking List ต้องมีข้อมูลลูกค้าอย่างน้อย 1 คน"
        );
      }
    } catch (error) {
      getAlert("FAILED", error);
    }
  }

  // const handleDragStart = (e, index) => {
  //   e.dataTransfer.setData("dragItemIndex", index);
  // };

  // const handleDrop = (e, dropIndex) => {
  //   const dragIndex = e.dataTransfer.getData("dragItemIndex");
  //   if (dragIndex === dropIndex) return;

  //   const updatedItems = [...formDetailList];
  //   const [draggedItem] = updatedItems.splice(dragIndex, 1);
  //   updatedItems.splice(dropIndex, 0, draggedItem);

  //   setFormDetailList(updatedItems);
  // };

  // const handleDragOver = (e) => {
  //   e.preventDefault();
  // };

  const handleMoveUp = (index) => {
    if (index === 0) return;
    const updatedItems = [...formDetailList];
    const temp = updatedItems[index];
    updatedItems[index] = updatedItems[index - 1];
    updatedItems[index - 1] = temp;
    setFormDetailList(updatedItems);
  };

  const handleMoveDown = (index) => {
    if (index === formDetailList.length - 1) return;
    const updatedItems = [...formDetailList];
    const temp = updatedItems[index];
    updatedItems[index] = updatedItems[index + 1];
    updatedItems[index + 1] = temp;
    setFormDetailList(updatedItems);
  };

  // Service ตรวจสอบเกี่ยวกับคลัง Vansale
  const [isVansaleCloseForWarehouse, setIsVansaleCloseForWarehouse] = useState(false);
  const hideVansaleCloseForWarehouse = async () => {
    setIsVansaleCloseForWarehouse(false);
    await onRowSelected(formMasterList.docNo);
    await getModelByNo();
  };

  // Service ตรวจสอบเกี่ยวกับเงิน Vansale
  const [isVansaleCloseForAccount, setIsVansaleCloseForAccount] = useState(false);
  const hideVansaleCloseForAccount = async () => {
    setIsVansaleCloseForAccount(false);
    await onRowSelected(formMasterList.docNo);
    await getModelByNo();
  };

  // ฟังก์ชันกรองข้อมูลตามชื่อ
  const filteredList = formDetailList.filter((data) =>
    data.arName && data.arName.toLowerCase().includes(searchCustomer.toLowerCase())
  );

  const [isAddCustomerModalOpen, setIsAddCustomerModalOpen] = useState(false);
  const [newCustomerName, setNewCustomerName] = useState("");
  const [newCustomerPhone, setNewCustomerPhone] = useState("");
  const [isAddingCustomer, setIsAddingCustomer] = useState(false);

  const handleAddCustomer = async () => {
    if (!newCustomerName) return getAlert("FAILED", "กรุณากรอกชื่อลูกค้า");

    getAlert("C_DIALOG", "ยืนยันการบันทึกลูกค้าใหม่", async (isConfirm) => {
      if (!isConfirm) return;

      if (isAddingCustomer) return;
      setIsAddingCustomer(true);

      try {
        // เช็กการซ้ำของชื่อก่อนบันทึก
        const existingCustomer = await getDataWithComp(
          "Tb_Set_Ar",
          `AND AR_Name = '${newCustomerName}' AND Comp_Id = '${localStorage.getItem("company")}'`
        );
        if (existingCustomer && existingCustomer.length > 0) {
          setIsAddingCustomer(false);
          return getAlert("FAILED", "ไม่สามารถบันทึกได้ เนื่องจากมีลูกค้าชื่อนี้อยู่ในระบบแล้ว");
        }

        // ทำการค้นหารหัสลูกค้า เพื่อให้ไม่ซ้ํา
        const existingCustomerCode = await getDataWithJoin(
          "MAX(AR_Code) AS maxCode",
          "Tb_Set_AR",
          "",
          `WHERE Comp_Id = '${localStorage.getItem("company")}'`
        );

        // ทำการสร้างรหัสลูกค้า
        const arCode = parseCurrency(existingCustomerCode[0]?.maxCode) + 1 || 0;

        await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/create-tb-set-ar`,
          {
            comp_id: localStorage.getItem("company"),
            ar_code: arCode,
            ar_name: newCustomerName,
            ar_type: localStorage.getItem("company") === "1" ? "11" : "5",
            ar_shortname: "",
            ar_taxno: "",
            default_price: null,
            item_series_list: null,
            ar_add1: "",
            ar_add2: "",
            ar_add3: "",
            ar_province: "",
            ar_zipcode: "",
            ar_contact1: "",
            ar_contact2: "",
            ar_tel1: newCustomerPhone,
            ar_tel2: "",
            ar_group: "",
            ar_refsalecode: "",
            ar_area: "",
            ar_status: "Y",
            ar_credit: 0,
            ar_vat: 0,
            ar_discount: 0,
            ar_branch: "",
            ar_bt_name: "",
            ar_addlat: "",
            ar_addlan: "",
            ar_refsale_name: "",
            ar_credit_term: 0,
            ar_credit_limit: 0,
            ar_sprice_id: null,
            ar_sprice_use: "N",
            ar_ice_pro: null,
            ar_item_free: "N",
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        // ค้นหาลูกค้าคนที่บันทึกไปมะกี้ กลับมาก่อน
        const getCustomer = await getDataWithComp(
          "Tb_Set_Ar",
          `AND AR_Code = '${arCode}'`
        );

        if (getCustomer && getCustomer.length > 0) {
          const selectedCustomer = getCustomer[0];
          const currentDeliveryLineId = deliveryLineId || formMasterList.deliveryLineId;
          // ค้นหาสายส่งด้วย Delivery_Line_Id ของ DL_Line_D
          if (selectedType === "DL" && currentDeliveryLineId) {
            const getDeliveryLines = await getDataWithJoin(
              "MAX(DL_Queue) AS maxQueue",
              "DL_Line_D",
              "",
              `WHERE Comp_Id = '${localStorage.getItem("company")}' AND DL_Id = ${currentDeliveryLineId}`
            );

            if (getDeliveryLines && getDeliveryLines.length > 0) {
              await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/create-dl-line-d`,
                {
                  dl_id: currentDeliveryLineId,
                  dl_queue: parseCurrency(getDeliveryLines[0]?.maxQueue) + 1,
                  dl_ar_id: selectedCustomer.AR_Id,
                  comp_id: localStorage.getItem("company"),
                  dl_ar_code: selectedCustomer.AR_Code || arCode,
                },
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );
            }
          }

          setArDataList((prevList) => {
            const exists = prevList.some((item) => item.AR_Id === selectedCustomer.AR_Id);
            return exists ? prevList : [...prevList, selectedCustomer];
          });

          setFormDetailList((prevList) => {
            const exists = prevList.some((item) => item.arId === selectedCustomer.AR_Id);
            if (exists) return prevList;

            return [
              ...prevList,
              {
                docId: null,
                dlQueue: prevList.length + 1,
                arId: selectedCustomer.AR_Id,
                arCode: selectedCustomer.AR_Code || arCode,
                arName: selectedCustomer.AR_Name,
                arShotName: selectedCustomer.AR_ShortName,
                soId: null,
                docNo: null,
              },
            ];
          });

        }

        setIsAddCustomerModalOpen(false);
        setNewCustomerName("");
        setNewCustomerPhone("");
        getAlert("OK", "เพิ่มลูกค้าสําเร็จ");
      } catch (error) {
        getAlert("FAILED", "เพิ่มลูกค้าไม่สําเร็จ");
      } finally {
        setIsAddingCustomer(false);
      }
    });
  };

  return (
    <>
      <Breadcrumbs
        page={maxDocNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        otherStatusName={reqStcStatusName}
        otherStatusColour={reqStcStatusColour}
        docStatusForClosePK={formMasterList.docStatus}
        items={[
          { name: "ขายสินค้า", url: "/sellproducts" },
          { name: name, url: "/picking-list" },
          {
            name: mode === "U" ? "เรียกดู " + name : "สร้าง " + name,
            url: "#",
          },
        ]}
        onHandleClick={() => getReport("pklist", formMasterList.docNo)}
        onHandleCloseForWarehouse={() => setIsVansaleCloseForWarehouse(true)}
        onHandleCloseForAccount={() => setIsVansaleCloseForAccount(true)}
        onHandleInvoice1={async () => {
          setIsLoading(true);
          await ExportVansaleSalesReport(formMasterList.docId, maxDocNo);
          setIsLoading(false);
        }}

      />
      <CloseVansaleForWarehouseModal
        isVansaleCloseForWarehouse={isVansaleCloseForWarehouse}
        hideVansaleCloseForWarehouse={hideVansaleCloseForWarehouse}
        pkId={formMasterList.docId}
        docStatus={docStatus}
        setDocStatus={setDocStatus}
        callInitialize={callInitialize}
      />
      <CloseVansaleForAccountModal
        isVansaleCloseForAccount={isVansaleCloseForAccount}
        hideVansaleCloseForAccount={hideVansaleCloseForAccount}
        pkId={formMasterList.docId}
        docStatus={docStatus}
        setDocStatus={setDocStatus}
        callInitialize={callInitialize}
      />

      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div className="hidden-scrollbar" style={{ maxHeight: "auto", overflowY: "auto" }}>
        {/* Modal for showing slip image */}
        {showSlipModal && (
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered modal-md" role="document">
              <div className="modal-content shadow-lg">
                <div className="modal-header" style={{ backgroundColor: "#EF6C00", color: "white" }}>
                  <h5 className="modal-title fw-bold">หลักฐานการโอน</h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowSlipModal(false)}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body d-flex justify-content-center align-items-center">
                  {slipImage === "" ? (
                    <h4 className="text-center">ไม่พบรูปภาพ</h4>
                  ) : (
                    <img
                      src={slipImage}
                      alt="หลักฐานการโอน"
                      style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: "10px",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="row mt-1">
          <div className="col-3 text-left">
            <DatePicker
              label="วันที่เอกสาร"
              name="docDate"
              value={formMasterList.docDate}
              onChange={(date) => handleChangeDateMaster(date, "docDate")}
              disabled={mode === "U"}
            />
          </div>
          <div className="col-4 text-left">
            <div className="d-flex align-items-center">
              <label>
                รถส่งสินค้า <span style={{ color: "red" }}>*</span>
              </label>
              <select
                name="pkCarId"
                value={formMasterList?.pkCarId || ""}
                onChange={(e) => handleChangeMaster(e)}
                className="form-select form-control input-spacing"
                disabled={selectedType === "" || mode === "U"}
              >
                <option value="">กรุณาเลือกรถส่งสินค้า</option>
                {carList
                  .filter((car) => car.Car_No && car.Car_Name)
                  .map((car, index) => {
                    // คำนวณค่า value ที่จะใช้
                    const carId =
                      selectedType === "SO" ? car.Car_id : car.DL_Car_id;
                    return (
                      <option key={index + 1} value={carId}>
                        {car.Car_No} ({car.Car_Name})
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList.createdDate}
                onChange={(e) => handleChangeMaster(e)}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเอกสาร</label>
              <div className="input-group">
                <input
                  type="text"
                  value={`สายส่ง : ${dlLineName}`}
                  className="form-control input-spacing"
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleSoShow}
                  disabled={mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <DeliveryModal
              showSoModal={showSoModal}
              handleSoClose={handleSoClose}
              soDataList={soDataList}
              dlLineList={dlLineList}
              onConfirmSoSelection={onConfirmSoSelection}
              onRowSelectDL={onRowSelectDL}
            />
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>
                คนขับรถส่งสินค้าที่ 1 <span style={{ color: "red" }}>*</span>
              </label>
              <select
                name="pkDriver1Id"
                value={formMasterList.pkDriver1Id}
                onChange={(e) => handleChangeMaster(e)}
                className="form-select form-control input-spacing"
                disabled={selectedType === "" || formMasterList.docStatus !== 1}
              >
                <option value="">กรุณาเลือกคนขับรถส่งสินค้าที่ 1</option>
                {driverList.map((driver) => (
                  <option key={driver.Emp_Id} value={driver.Emp_Id}>
                    {driver.Emp_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList.createdByName || ""}
                onChange={(e) => handleChangeMaster(e)}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>รอบ</label>
              <select
                name="pkRound"
                value={formMasterList.pkRound || ""}
                onChange={(e) => handleChangeMaster(e)}
                disabled={mode === "U"}
                className="form-select form-control input-spacing"
              >
                <option value="1">เช้า</option>
                <option value="2">เย็น</option>
                <option value="3">ค่ำ</option>
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>คนขับรถส่งสินค้าที่ 2</label>
              <select
                name="pkDriver2Id"
                value={formMasterList.pkDriver2Id}
                onChange={(e) => handleChangeMaster(e)}
                className="form-select form-control input-spacing"
                disabled={selectedType === "" || formMasterList.docStatus !== 1}
              >
                <option value="">กรุณาเลือกคนขับรถส่งสินค้าที่ 2</option>
                {driverList.map((driver) => (
                  <option key={driver.Emp_Id} value={driver.Emp_Id}>
                    {driver.Emp_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                onChange={(e) => handleChangeMaster(e)}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
            <label>ประเภทเอกสาร</label>
            <select
              className="form-select form-control input-spacing"
              name="docType"
              value={formMasterList.docType}
              onChange={handleChangeMaster}
              disabled={formMasterList.docStatus !== 1}
            >
              {tbDocType.map((docType) => (
                <option key={docType.DocType_Id} value={docType.DocType_Id}>
                  {docType.DocType_Name}
                </option>
              ))}
            </select>
          </div> */}
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>คนขับรถส่งสินค้าที่ 3</label>
              <select
                name="pkDriver3Id"
                value={formMasterList.pkDriver3Id}
                onChange={(e) => handleChangeMaster(e)}
                className="form-select form-control input-spacing"
                disabled={selectedType === "" || formMasterList.docStatus !== 1}
              >
                <option value="">กรุณาเลือกคนขับรถส่งสินค้าที่ 3</option>
                {driverList.map((driver) => (
                  <option key={driver.Emp_Id} value={driver.Emp_Id}>
                    {driver.Emp_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                onChange={(e) => handleChangeMaster(e)}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3" />
          <div className="col-4" />
          <div className="col-2" />
          <div className="col-3" />
        </div>
        <div className="row mt-1">
          <div className="col-3" />
          <div className="col-6" />
          <div className="col-3" />
        </div>
        <div className="row mt-1">
          <div className="col-3" />
          <div className="col-6" />
          <div className="col-3" />
        </div>
        <hr />
        <div className="row">
          <div className="col-4" style={{ borderRight: "2px solid #c7c8c9" }}>
            <div className="col-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title">
                    รายชื่อลูกค้า ({filteredList.length || 0})
                  </h4>
                  <div className="d-flex gap-2 align-items-center">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="ค้นหาชื่อลูกค้า"
                      value={searchCustomer}
                      onChange={(e) => setSearchCustomer(e.target.value)}
                      style={{ width: '200px' }}
                    />
                    <button
                      className="btn btn-outline-secondary"
                      onClick={handleArShow}
                      disabled={selectedType === ""}
                    >
                      <i className="fas fa-search" />
                    </button>
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => setIsAddCustomerModalOpen(true)}
                      disabled={selectedType === ""}
                    >
                      <i className="fas fa-user-plus" />
                    </button>

                    <ArModal
                      showArModal={showArModal}
                      handleArClose={handleArClose}
                      arDataList={arDataList}
                      onRowSelectAr={onRowSelectAr}
                    />

                    {/* Modal สำหรับเพิ่มลูกค้า */}
                    <div
                      className={`modal fade ${isAddCustomerModalOpen ? 'show' : ''}`}
                      style={{ display: isAddCustomerModalOpen ? 'block' : 'none' }}
                      tabIndex="-1"
                      role="dialog"
                    >
                      <div className="modal-dialog modal-md" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">เพิ่มลูกค้าใหม่</h5>
                            <button
                              type="button"
                              className="close"
                              onClick={() => setIsAddCustomerModalOpen(false)}
                            >
                              <span>&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <div className="form-group mb-3">
                              <label>ชื่อลูกค้า</label>
                              <input
                                type="text"
                                className="form-control"
                                value={newCustomerName}
                                onChange={(e) => setNewCustomerName(e.target.value)}
                                placeholder="กรอกชื่อลูกค้า"
                              />
                            </div>
                            <div className="form-group mb-2">
                              <label>เบอร์โทร</label>
                              <input
                                type="tel"
                                className="form-control"
                                value={newCustomerPhone}
                                onChange={(e) => setNewCustomerPhone(e.target.value)}
                                placeholder="กรอกเบอร์โทร"
                              />
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              className="btn btn-danger"
                              onClick={() => setIsAddCustomerModalOpen(false)}
                            >
                              ยกเลิก
                            </button>
                            <button
                              className="btn btn-success"
                              onClick={handleAddCustomer}
                              disabled={isAddingCustomer}
                            >
                              {isAddingCustomer ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                  กำลังบันทึก...
                                </>
                              ) : (
                                'บันทึก'
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isAddCustomerModalOpen && (
                      <div className="modal-backdrop fade show"></div>
                    )}
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                    <table id="basic-datatables" className="table table-striped table-hover">
                      <thead className="thead-dark">
                        <tr>
                          <th className="text-center" style={{ width: "5%" }}>ลำดับ</th>
                          <th className="text-center" style={{ width: "65%" }}>ชื่อลูกค้า</th>
                          <th className="text-center" style={{ width: "25%" }}>สถานะ</th>
                          <th className="text-center" style={{ width: "5%" }}>ลบ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedType !== "" && filteredList.length > 0 ? (
                          filteredList.map((data, index) => (
                            <tr
                              key={data.docId || index + 1}
                              style={{
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                              }}
                              onClick={() => handleDisplayItem(data)}
                            >
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn btn-link"
                                  onClick={() => handleMoveUp(index)}
                                  disabled={index === 0}
                                >
                                  <i
                                    className="fas fa-arrow-up"
                                    style={{
                                      color: index === 0 ? "#c0c0c0" : "#EF6C00",
                                    }}
                                  />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-link"
                                  onClick={() => handleMoveDown(index)}
                                  disabled={index === filteredList.length - 1}
                                >
                                  <i
                                    className="fas fa-arrow-down"
                                    style={{
                                      color: index === filteredList.length - 1 ? "#c0c0c0" : "#EF6C00",
                                    }}
                                  />
                                </button>
                              </td>
                              <td className="text-left">
                                {data.dlQueue}. {data.arName}
                                <div
                                  style={{
                                    color: "#A9A9A9",
                                    fontSize: "0.85em",
                                    fontWeight: 300,
                                    marginTop: "4px",
                                  }}
                                >
                                  {data.arShotName}
                                </div>
                              </td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn"
                                  style={{
                                    backgroundColor: data.soId ? "green" : "orange",
                                    color: "white",
                                  }}
                                >
                                  {data.soId ? "จัดส่ง" : "ไม่จัดส่ง"}
                                </button>
                              </td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  onClick={(event) => data.soId ? getAlert('FAILED', 'ไม่สามารถลบรายการได้ เนื่องจากมีรายการจัดส่ง') : handleRemove(index, event)}
                                  disabled={formMasterList.docStatus !== 1 || data.soId}
                                >
                                  ลบ
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5">
                              <center>
                                <h5>ไม่พบข้อมูล</h5>
                              </center>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="mt-3 d-flex justify-content-end gap-2">
                    {mode === 'I' && (
                      <button
                        className="btn btn-outline-danger"
                        onClick={() => setShowConfirmDeleteAllCustomerModal(true)}
                        disabled={filteredList.length === 0 || formMasterList.docStatus !== 1}
                      >
                        ลบลูกค้าทั้งหมด
                      </button>
                    )}
                  </div>
                  {showConfirmDeleteAllCustomerModal && (
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                      <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">ยืนยันการลบลูกค้าทั้งหมด</h5>
                            <button type="button" className="btn-close" onClick={() => setShowConfirmDeleteAllCustomerModal(false)}></button>
                          </div>
                          <div className="modal-body">
                            <p>คุณแน่ใจหรือไม่ว่าต้องการลบลูกค้าทั้งหมด?</p>
                          </div>
                          <div className="modal-footer">
                            <button type="button" className="btn btn-danger" onClick={() => setShowConfirmDeleteAllCustomerModal(false)}>
                              ยกเลิก
                            </button>
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={() => {
                                setFormDetailList([]);
                                setShowConfirmDeleteAllCustomerModal(false);
                              }}
                            >
                              ยืนยัน
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-8">
            <div className="card">
              <div className="card-header">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === "deliveryDetails" ? "active" : ""
                        }`}
                      onClick={() => handleChangeTabs("deliveryDetails")}
                    >
                      รายละเอียดการส่งสินค้า
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === "stockRemaining" ? "active" : ""
                        }`}
                      onClick={() => handleChangeTabs("stockRemaining")}
                    >
                      สินค้าคงเหลือ
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === "withdraw" ? "active" : ""
                        }`}
                      onClick={() => handleChangeTabs("withdraw")}
                    >
                      รายการนำเข้า
                    </button>
                  </li>
                </ul>
              </div>
              <div className="card-body">
                {activeTab === "deliveryDetails" && (
                  <>
                    {Array.isArray(soListData) && soListData.length > 0 ? (
                      soListData.map((soData, index) => {
                        // คำนวณยอดรวมของใบขายปัจจุบัน
                        const totals = soData.details
                          ? soData.details
                            .filter((detail) => detail.Item_Qty > 0)
                            .reduce(
                              (acc, detail) => {
                                const discountValue =
                                  detail.Item_DisType === "2"
                                    ? (detail.Item_Total / 100) * detail.Item_Discount
                                    : detail.Item_Discount;
                                const priceAfterDiscount = detail.Item_Total - discountValue;
                                const vat = detail.IsVat === 1 ? priceAfterDiscount * 0.07 : 0;
                                const totalPrice = priceAfterDiscount + vat;

                                return {
                                  totalItemPrice: acc.totalItemPrice + detail.Item_Total,
                                  totalDiscount: acc.totalDiscount + discountValue,
                                  totalPriceAfterDiscount:
                                    acc.totalPriceAfterDiscount + priceAfterDiscount,
                                  totalVat: acc.totalVat + vat,
                                  grandTotal: acc.grandTotal + totalPrice,
                                };
                              },
                              {
                                totalItemPrice: 0,
                                totalDiscount: 0,
                                totalPriceAfterDiscount: 0,
                                totalVat: 0,
                                grandTotal: 0,
                              }
                            )
                          : {
                            totalItemPrice: 0,
                            totalDiscount: 0,
                            totalPriceAfterDiscount: 0,
                            totalVat: 0,
                            grandTotal: 0,
                          };

                        return (
                          <div className="card shadow-sm mb-4" key={index}>
                            <div
                              className="card-header text-white d-flex justify-content-between align-items-center"
                              style={{ backgroundColor: "#EF6C00" }}
                            >
                              <h5 className="mb-0 d-flex align-items-center justify-content-between">
                                <span style={{ marginRight: "20px" }}>
                                  ใบขาย: <span className="fw-bold">{soData.Doc_No}</span>
                                </span>
                                {soData.DocStatusPaid_Type_Name === "จ่ายหลายช่องทาง" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "10px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    {paymentHistory?.map((pay, index) => (
                                      <button
                                        key={index}
                                        className="btn btn-md"
                                        style={{
                                          backgroundColor:
                                            pay.Pay_Type === 1
                                              ? "green"
                                              : pay.Pay_Type === 2
                                                ? "blue"
                                                : pay.Pay_Type === 3
                                                  ? "purple"
                                                  : "gray",
                                          fontSize: "16px",
                                          color: "white",
                                          userSelect: "none",
                                        }}
                                        onClick={async () => {
                                          if (pay.Pay_Type === 2) {
                                            handleShowImage(soData);
                                          }
                                          if (pay.Pay_Type === 3) {
                                            setShowChequeModal(true);
                                          }
                                        }}
                                      >
                                        {pay.Pay_Type === 1
                                          ? "เงินสด"
                                          : pay.Pay_Type === 2
                                            ? "เงินโอน"
                                            : pay.Pay_Type === 3
                                              ? "เช็ค"
                                              : "ไม่ทราบ"}{" "}
                                        ({formatCurrency(pay.Pay_Amount)} ฿)
                                      </button>
                                    ))}
                                  </div>
                                ) : (
                                  <span
                                    className="badge text-white"
                                    style={{
                                      backgroundColor: soData.DocStatusPaidType_Colour,
                                      fontSize: "1.1rem",
                                      padding: "0.5rem 1rem",
                                      borderRadius: "0.5rem",
                                    }}
                                    onClick={() => {
                                      if (soData.DocStatusPaid_Type_Name === "เงินโอน") {
                                        setShowSlipModal(true);
                                      }
                                      if (soData.DocStatusPaid_Type_Name === "เช็ค") {
                                        setShowChequeModal(true);
                                      }
                                    }}
                                  >
                                    {soData.DocStatusPaid_Type_Name}{" "}
                                    {soData.DocStatusPaid_Type_Name === "เงินสด" ||
                                      soData.DocStatusPaid_Type_Name === "เงินโอน"
                                      ? `(${formatCurrency(soData.Pay_Total)} ฿)`
                                      : soData.DocStatusPaid_Type_Name === "ค้างจ่าย"
                                        ? `(${formatCurrency(soData.NetTotal - soData.Pay_Total)} ฿)`
                                        : ""}
                                  </span>
                                )}
                              </h5>
                              <div>
                                {/* ปุ่มดูหลักฐานเงินโอน */}
                                {soData.DocStatusPaid_Type_Name === "เงินโอน" && (
                                  <button
                                    className="btn btn-light btn-md me-2"
                                    onClick={() => {
                                      handleShowImage(soData);
                                    }}
                                  >
                                    <i className="fa fa-eye"></i> ดูหลักฐานเงินโอน
                                  </button>
                                )}
                                <button
                                  className="btn btn-light btn-md me-2"
                                  onClick={() => handleViewSo(soData)}
                                >
                                  <i className="fa fa-eye"></i> ดูใบขาย
                                </button>
                                <button
                                  className="btn btn-light btn-md"
                                  onClick={() => getReport("rc", soData.Doc_No)}
                                >
                                  <i className="fa fa-print"></i> พิมพ์บิล
                                </button>
                              </div>
                              {/* Modal สำหรับแสดงเช็ค */}
                              {showChequeModal && (
                                <div
                                  className="modal"
                                  style={{
                                    display: "block",
                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    zIndex: 1050,
                                  }}
                                >
                                  <div className="modal-dialog modal-md" role="document">
                                    <div
                                      className="modal-content shadow-lg"
                                      style={{ borderRadius: "15px", overflow: "hidden" }}
                                    >
                                      <div
                                        className="modal-header"
                                        style={{
                                          backgroundColor: "#EF6C00",
                                          borderBottom: "none",
                                          padding: "20px",
                                        }}
                                      >
                                        <h5 className="modal-title fw-bold text-white">เช็ค</h5>
                                      </div>
                                      <div className="modal-body">
                                        <div
                                          class="p-3 rounded mt-4"
                                          style={{ backgroundColor: "#DCDCDC" }}
                                        >
                                          <h6 class="fw-bold mb-3">รายละเอียดเช็ค</h6>
                                          <div class="row g-3">
                                            <div class="col-12">
                                              <label class="form-label fw-bold">เลขที่เช็ค</label>
                                              <input
                                                type="text"
                                                class="form-control"
                                                value={chequeNo}
                                                disabled={true}
                                              />
                                            </div>
                                            <div class="col-12">
                                              <label class="form-label fw-bold">ชื่อเช็ค</label>
                                              <input
                                                type="text"
                                                class="form-control"
                                                value={chequeName}
                                                disabled={true}
                                              />
                                            </div>
                                            <div class="col-12">
                                              <label class="form-label fw-bold">ธนาคาร</label>
                                              <input
                                                type="text"
                                                class="form-control"
                                                value={chequeBranch}
                                                disabled={true}
                                              />
                                            </div>
                                            <div class="col-12">
                                              <label class="form-label fw-bold">วันที่</label>
                                              <DatePicker
                                                value={chequeDate}
                                                onChange={(date) =>
                                                  setChequeDate(
                                                    date ? date.format("YYYY-MM-DD") : null
                                                  )
                                                }
                                                disabled={true}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="modal-footer" style={{ borderTop: "none" }}>
                                        <button
                                          type="button"
                                          className="btn btn-danger me-2"
                                          style={{ borderRadius: "5px" }}
                                          onClick={() => setShowChequeModal(false)}
                                        >
                                          ปิด
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="card-body">
                              <div className="d-flex flex-wrap justify-content-between align-items-center text-center gap-3">
                                <div className="flex-grow-1">
                                  <strong>วันที่:</strong>{" "}
                                  {formatDate(soData.Doc_Date)}
                                </div>
                                <div className="flex-grow-1">
                                  <strong>สถานะเอกสาร:</strong>{" "}
                                  <span
                                    className="badge text-white"
                                    style={{
                                      backgroundColor: soData.DocStatus_Colour,
                                      fontSize: "1.1rem",
                                      padding: "0.5rem 1rem",
                                      borderRadius: "0.5rem",
                                    }}
                                  >
                                    {soData.DocStatus_Name}
                                  </span>
                                </div>
                                <div className="flex-grow-1">
                                  <strong>สถานะจ่าย:</strong>{" "}
                                  <span
                                    className="badge text-white"
                                    style={{
                                      backgroundColor:
                                        soData.DocStatusPaid_Colour,
                                      fontSize: "1.1rem",
                                      padding: "0.5rem 1rem",
                                      borderRadius: "0.5rem",
                                    }}
                                  >
                                    {soData.DocStatusPaid_Name}
                                  </span>
                                </div>
                                <div className="flex-grow-1">
                                  <strong>สถานะ VAT:</strong>{" "}
                                  <span
                                    className="badge text-white"
                                    style={{
                                      backgroundColor:
                                        soData.IsVat === 1 ? "green" : "red",
                                      fontSize: "1.1rem",
                                      padding: "0.5rem 1rem",
                                      borderRadius: "0.5rem",
                                    }}
                                  >
                                    {soData.IsVat === 1 ? "VAT" : "NO VAT"}
                                  </span>
                                </div>
                              </div>

                              {/* รายการสินค้า */}
                              <div className="mt-4">
                                <details className="mt-3">
                                  <summary
                                    className="fw-bold mb-3"
                                    style={{
                                      cursor: "pointer",
                                      color: "#EF6C00",
                                      fontSize: "1.2rem",
                                      borderBottom: "1px solid #ddd",
                                      paddingBottom: "0.3rem",
                                      marginLeft: "25px",
                                    }}
                                  >
                                    ดูรายการสินค้า
                                  </summary>
                                  {soData.details && soData.details.length > 0 ? (
                                    <>
                                      {/* แสดงรายการสินค้า */}
                                      {soData.details
                                        .filter((detail) => detail.Item_Qty > 0)
                                        .map((detail, idx) => (
                                          <div
                                            key={idx}
                                            className="card mb-3 p-3"
                                            style={{
                                              border: "1px solid #ddd",
                                              borderRadius: "10px",
                                              backgroundColor: "#fff",
                                              marginLeft: "25px",
                                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                            }}
                                          >
                                            <div className="d-flex justify-content-between">
                                              <h5 className="mb-1">
                                                <strong>สินค้า: {detail.Item_Name}</strong>
                                              </h5>
                                              <span className="text-muted">(รหัส: {detail.Item_Code})</span>
                                            </div>
                                            <div className="mt-2">
                                              <p className="mb-1">
                                                <strong>จำนวน:</strong> {detail.Item_Qty} {detail.Item_Unit}
                                              </p>
                                              <p className="mb-1">
                                                <strong>ราคาต่อหน่วย:</strong> {formatCurrency(detail.Item_Price_Unit)} ฿
                                              </p>
                                              <p className="mb-1">
                                                <strong>ราคารวมต่อไอเทม:</strong> {formatCurrency(detail.Item_Total)} ฿
                                              </p>
                                            </div>
                                          </div>
                                        ))}

                                      {/* คำนวณผลรวม */}
                                      {(() => {
                                        const totals = soData.details
                                          .filter((detail) => detail.Item_Qty > 0)
                                          .reduce(
                                            (acc, detail) => {
                                              const discountValue =
                                                detail.Item_DisType === "2"
                                                  ? (detail.Item_Total / 100) * detail.Item_Discount
                                                  : detail.Item_Discount;
                                              const priceAfterDiscount = detail.Item_Total - discountValue;
                                              const vat = detail.IsVat === 1 ? priceAfterDiscount * 0.07 : 0;
                                              const totalPrice = priceAfterDiscount + vat;

                                              return {
                                                totalItemPrice: acc.totalItemPrice + detail.Item_Total,
                                                totalDiscount: acc.totalDiscount + discountValue,
                                                totalPriceAfterDiscount: acc.totalPriceAfterDiscount + priceAfterDiscount,
                                                totalVat: acc.totalVat + vat,
                                                grandTotal: acc.grandTotal + totalPrice,
                                              };
                                            },
                                            {
                                              totalItemPrice: 0,
                                              totalDiscount: 0,
                                              totalPriceAfterDiscount: 0,
                                              totalVat: 0,
                                              grandTotal: 0,
                                            }
                                          );

                                        return (
                                          <div
                                            className="card mt-4 p-4"
                                            style={{
                                              backgroundColor: "#ffffff",
                                              marginLeft: "25px",
                                              border: "1px solid #ddd",
                                              borderRadius: "12px",
                                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                            }}
                                          >
                                            <h5
                                              style={{
                                                marginBottom: "1rem",
                                                color: "#EF6C00",
                                                fontWeight: "bold",
                                                borderBottom: "2px solid #ddd",
                                                paddingBottom: "0.5rem",
                                                fontSize: "1.2rem",  // เพิ่มขนาดตัวอักษรให้โดดเด่นขึ้น
                                              }}
                                            >
                                              ผลรวมรายการสินค้า
                                            </h5>
                                            <div
                                              className="d-flex justify-content-between align-items-center mb-2"
                                              style={{
                                                padding: "0.3rem 0",
                                                fontSize: "1rem",  // ขนาดตัวอักษรพอดี
                                                color: "#333",
                                              }}
                                            >
                                              <span><strong>รวมราคา:</strong></span>
                                              <span>{formatCurrency(totals.totalItemPrice)} ฿</span>
                                            </div>
                                            <div
                                              className="d-flex justify-content-between align-items-center mb-2"
                                              style={{
                                                padding: "0.3rem 0",
                                                fontSize: "1rem",
                                                color: "#333",
                                              }}
                                            >
                                              <span><strong>รวมส่วนลด:</strong></span>
                                              <span>{formatCurrency(totals.totalDiscount)} ฿</span>
                                            </div>
                                            <div
                                              className="d-flex justify-content-between align-items-center mb-2"
                                              style={{
                                                padding: "0.3rem 0",
                                                fontSize: "1rem",
                                                color: "#333",
                                              }}
                                            >
                                              <span><strong>ราคาหลังหักส่วนลด:</strong></span>
                                              <span>{formatCurrency(totals.totalPriceAfterDiscount)} ฿</span>
                                            </div>
                                            <div
                                              className="d-flex justify-content-between align-items-center mb-2"
                                              style={{
                                                padding: "0.3rem 0",
                                                fontSize: "1rem",
                                                color: "#333",
                                              }}
                                            >
                                              <span><strong>VAT (7%):</strong></span>
                                              <span>{formatCurrency(totals.totalVat)} ฿</span>
                                            </div>
                                            <div
                                              className="mt-3 text-center"
                                              style={{
                                                backgroundColor: "#1E90FF", // เปลี่ยนสีพื้นหลังให้ดูสะดุดตา
                                                color: "#fff",
                                                padding: "0.8rem",
                                                borderRadius: "8px",
                                                fontSize: "1.3rem",  // ขนาดฟอนต์ที่พอดี
                                                fontWeight: "bold",
                                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",  // เพิ่มเงาให้ดูน่าสนใจ
                                              }}
                                            >
                                              รวมทั้งสิ้น: {formatCurrency(totals.grandTotal)} ฿
                                            </div>
                                          </div>
                                        );
                                      })()}
                                    </>
                                  ) : (
                                    <div className="text-center text-muted">
                                      <p>ไม่มีรายการสินค้า</p>
                                    </div>
                                  )}
                                </details>
                              </div>


                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center">
                        <h5 className="text-muted">ไม่พบรายการขาย</h5>
                      </div>
                    )}
                  </>
                )}

                {activeTab === "stockRemaining" && (
                  <>
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h4 className="card-title mb-0">สินค้าคงเหลือ</h4>
                    </div>
                    <div className="card-body">
                      <div
                        className="table-responsive"
                        style={{ maxHeight: "400px", overflowY: "auto" }}
                      >
                        <table
                          id="basic-datatables"
                          className="table table-striped table-hover"
                        >
                          <thead className="thead-dark">
                            <tr>
                              <th
                                className="text-center"
                                style={{ width: "10%" }}
                              >
                                รหัสสินค้า
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "50%" }}
                              >
                                ชื่อสินค้า
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "10%" }}
                              >
                                คงเหลือ
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "15%" }}
                              >
                                หน่วย
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "15%" }}
                              >
                                วันที่ทำรายการล่าสุด
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {formItemOnHandCaseTab.length > 0 ? (
                              formItemOnHandCaseTab.map((item, index) => (
                                <tr key={item.Item_Id || index + 1}>
                                  <td className="text-center">
                                    {item.Item_Code}
                                  </td>
                                  <td className="text-left">
                                    {item.Item_Name}
                                  </td>
                                  <td className="text-center">
                                    {item.Item_Onhand}
                                  </td>
                                  <td className="text-center">
                                    {item.Item_Unit_ST}
                                  </td>
                                  <td className="text-center">
                                    {item.Last_STC_Date
                                      ? formatDate(item.Last_STC_Date)
                                      : ""}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={10}>
                                  <center>
                                    <h5>
                                      {formMasterList.pkCarId === ""
                                        ? "กรุณาเลือก รถส่งสินค้า ก่อน"
                                        : "ไม่พบรายการสินค้าคงเหลือ"}
                                    </h5>
                                  </center>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                )}

                {activeTab === "withdraw" && (
                  <>
                    <div className="card-header justify-content-between align-items-center">
                      <div className="row">
                        <div className="col-4">
                          <h4 className="card-title">รายการนำเข้า</h4>
                        </div>
                        <div className="col-8 d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-success mr-2"
                            hidden={formItemWithdrawCaseTab.length < 1}
                            onClick={() => handleConfirmImport()}
                            disabled={onLoadConfirm}
                          >
                            <i className="fa fa-check"></i>{" "}
                            ยืนยันการนำเข้าสินค้า
                          </button>

                          <button
                            className="btn text-white mx-3"
                            onClick={handleImportShow}
                            style={{
                              backgroundColor: "rgb(239, 108, 0)",
                              whiteSpace: "nowrap",
                              padding: "10px",
                              fontSize: "15px",
                            }}
                            disabled={
                              mode !== "U" ||
                              selectedType === "" ||
                              formMasterList.docStatus !== 1
                            }
                          >
                            <i className="fa fa-plus"></i> นำเข้าสินค้า
                          </button>
                        </div>
                      </div>
                      {showImportModal && (
                        <ImportModal
                          onConfirmImportSelection={onConfirmImportSelection}
                          showImportModal={showImportModal}
                          handleImportClose={handleImportClose}
                          name={name}
                          pickingList={formMasterList}
                          selectedImports={selectedImports}
                        />
                      )}
                    </div>
                    <div className="card-body">
                      <TeasuryTable dataList={formItemWithdrawCaseTab} />
                    </div>
                    <div className="card-footer">
                      <button
                        type="button"
                        className="btn btn-danger"
                        hidden={formItemWithdrawCaseTab.length < 1}
                        onClick={() => handleRemoveFormWd()}
                        disabled={onLoadConfirm}
                      >
                        <i className="fa fa-times"></i> ยกเลิกการนำเข้าสินค้า
                      </button>
                    </div>
                  </>
                )}
              </div>

              {showViewSoModal && selectedSoData && (
                <ViewSoModal
                  showViewSoModal={showViewSoModal}
                  handleViewSoClose={handleViewSoClose} // ใช้ฟังก์ชันปิด Modal
                  mode={"U"}
                  name={`ใบขายสินค้าเลขที่ ${selectedSoData.Doc_No}`}
                  maxDocNo={selectedSoData.Doc_No} // ส่งหมายเลขใบขาย
                />
              )}
            </div>
          </div>
        </div>
        <div className="row mt-5">
          <div
            className="col-3"
            style={{ borderRight: "2px solid #c7c8c9" }}
          ></div>
          {/* <div className="col-9">
          <Summary
            formMasterList={formMasterList}
            handleChangeMaster={handleChangeMaster}
            selectedDiscountValueType={selectedDiscountValueType}
            handleCheckboxChange={handleCheckboxChange}
            receiptDiscount={receiptDiscount}
            formatCurrency={formatCurrency}
            totalPrice={totalPrice}
            subFinal={subFinal}
            isVatChecked={isVatChecked}
            handleVatChange={handleVatChange}
            vatAmount={vatAmount}
            grandTotal={grandTotal}
            disabled={false}
          />
        </div> */}
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <FormAction
            onSubmit={handleSubmit}
            onUpdate={handleUpdate}
            onCancel={handleCancel}
            mode={mode}
            setMode={setMode}
            disabled={formMasterList.docStatus === 1 ? false : true}
            footer={true}
          />
        </div>
      </div>
    </>
  );
}

export default Form;
